import 'rc-slider/assets/index.css'
import './styles.scss'

import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'
import { Range } from 'rc-slider'

import PriceTag from 'lib/tags/price'

import filtersLogic from '~/scenes/search/filters-page/logic'

function convert (price, currencyRate) {
  return (((price || 0) * (currencyRate || 1)).toPrecision(2) - 0 + '').split('.')[0] - 0
}

export default function Price () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)

  const { currency, currency_rate: currencyRate, price } = unsavedFilter

  const [priceFrom, priceTo] = price.split(',').map(i => parseInt(i))

  return (
    <div className='filter-section'>
      <span className='filter-title'>{I18n.t('react.search.filters.price.title')}</span>
      <div className='price-slider'>
        <span className='price left'>
          <PriceTag price={convert(priceFrom, currencyRate)} currency={currency} />
          <div className='size'>
            <PriceTag price={convert(100, currencyRate)} currency={currency} />
          </div>
        </span>
        <span className='slider'>
          <Range
            reverse={I18n.locale === 'ar'}
            range
            value={[priceFrom, priceTo]}
            onChange={price => updateUnsavedFilter({ price: price.join(',') })}
            tipFormatter={value => convert(value, currencyRate)}
          />
        </span>
        <span className='price right'>
          <PriceTag price={convert(priceTo, currencyRate)} currency={currency} postPrice={priceTo === 100 ? '+' : ''} />
          <div className='size'>
            <PriceTag price={convert(100, currencyRate)} currency={currency} postPrice='+' />
          </div>
        </span>
      </div>
    </div>
  )
}
